import type { HexMapState } from '../../../engine/render/renderer';
import type { Tile } from '../../../engine/hex/types';
import type { ContentBuilder } from '../../ui/ContentBuilder';
import { getPopulationCount } from '../../../engine/map/settlement';
import { t } from '../../../i18n/translations';
import { ACTION__TILE__OPEN_FOUNDING } from '../../../engine/input/actionIds';
import { getFoundingStatus } from '../utils';

export function renderTileSettlementTab(
    builder: ContentBuilder,
    state: HexMapState,
    tile: Tile,
): void {
    const lang = state.config.ui.language;
    const settlement = state.settlementByTileId[tile.id];
    if (settlement) {
        builder.section(t(lang, 'tile.occupied'), (section) => {
            section.text(t(lang, 'tile.settlementName', settlement.name));
            section.text(t(lang, 'tile.settlementPopulation', getPopulationCount(settlement)));
            section.text(t(lang, 'tile.settlementTier', t(lang, `tier.${settlement.tier}`)));
        });
        return;
    }

    if (!state.discoveredTileIds.has(tile.id)) {
        builder.section(t(lang, 'tile.undiscovered'), (section) => {
            section.text(t(lang, 'tile.undiscoveredHint'), 'muted');
        });
        return;
    }

    const status = getFoundingStatus(state, tile.id);
    builder.section(t(lang, 'tile.unoccupied'), (section) => {
        section.text(
            status.isControlled ? t(lang, 'tile.controlled') : t(lang, 'tile.uncontrolled'),
            'muted',
        );
        section.text(
            status.isControlled ? t(lang, 'tile.controlledHint') : t(lang, 'tile.uncontrolledHint'),
        );
        if (status.hasExpedition) {
            section.text(t(lang, 'tile.foundingInProgress'), 'muted');
        }
        section.text(t(lang, 'tile.foundRequirement', status.requiredPopulation));
        section.text(t(lang, 'tile.foundFreePopulation', status.freePopulation));
        section.button(
            ACTION__TILE__OPEN_FOUNDING,
            t(lang, 'actions.foundSettlement', status.requiredPopulation),
            status.canFound,
        );
    });
}
